import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { calculateTruncation } from './truncateText-compiled';
var truncateCommonStyles = "\n  display: inline-block;\n  vertical-align: bottom;\n  white-space: nowrap;\n  overflow: hidden;\n";

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var TruncateLeft = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", "\n\tmax-width: calc(100% - ", "em);\n\tmin-width: ", ";\n\ttext-overflow: ellipsis;\n"])), truncateCommonStyles, function (_ref) {
  var fontSizePX = _ref.fontSizePX,
    endFixedChars = _ref.endFixedChars;
  return fontFaceScaleFactor(fontSizePX) * endFixedChars + 1;
}, function (_ref2) {
  var fontSizePX = _ref2.fontSizePX,
    startFixedChars = _ref2.startFixedChars;
  return fontFaceScaleFactor(fontSizePX) * startFixedChars;
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var TruncateRight = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t", "\n\tmax-width: calc(100% - ", ");\n\tposition: relative;\n"])), truncateCommonStyles, function (_ref3) {
  var fontSizePX = _ref3.fontSizePX,
    startFixedChars = _ref3.startFixedChars;
  return fontFaceScaleFactor(fontSizePX) * startFixedChars;
});
var fontFaceScaleFactor = function fontFaceScaleFactor(fontSizePX) {
  return fontSizePX / 11 * 0.46;
}; /* factor for fontSize of 11px */

var placeholder = ' ';
export var Truncate = function Truncate(_ref4) {
  var text = _ref4.text,
    _ref4$fontSizePX = _ref4.fontSizePX,
    fontSizePX = _ref4$fontSizePX === void 0 ? 11 : _ref4$fontSizePX,
    _ref4$startFixedChars = _ref4.startFixedChars,
    startFixedChars = _ref4$startFixedChars === void 0 ? 4 : _ref4$startFixedChars,
    _ref4$endFixedChars = _ref4.endFixedChars,
    endFixedChars = _ref4$endFixedChars === void 0 ? 7 : _ref4$endFixedChars;
  var _calculateTruncation = calculateTruncation(text, startFixedChars, endFixedChars),
    leftStr = _calculateTruncation.left,
    rightStr = _calculateTruncation.right;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TruncateLeft, {
    fontSizePX: fontSizePX,
    startFixedChars: startFixedChars,
    endFixedChars: endFixedChars,
    "data-testid": "truncate-left"
  }, leftStr), /*#__PURE__*/React.createElement(TruncateRight, {
    fontSizePX: fontSizePX,
    startFixedChars: startFixedChars,
    endFixedChars: endFixedChars,
    "data-testid": "truncate-right"
  }, leftStr === rightStr ? placeholder : rightStr));
};